import { useMemo } from 'react';
import { useOptionalActiveSession } from '../api/active/sessionProvider';
import { createCatalogSessionScopeKey } from './catalogSessionResource';

export const CATALOG_SIGNED_PREVIEW_CACHE_MAX_AGE_MS = 4 * 60 * 1_000;

export function useCatalogSessionScope(): string | null {
  const session = useOptionalActiveSession();
  return useMemo(() => {
    if (session?.state.status !== 'ready') return null;
    const user = session.state.user;
    return createCatalogSessionScopeKey({
      actorUserId: user.id,
      companyId: user.companyId,
      permissionVersion: user.permissionVersion,
      roleViewId: user.roleView?.roleId,
      roleViewPolicyVersion: user.roleView?.policyVersion,
      permissionDataScopes: user.permissionDataScopes,
      permissions: user.permissions,
      dataScopes: user.dataScopes,
      departments: user.departments,
      primaryDepartmentId: user.primaryDepartmentId,
    });
  }, [session?.state]);
}
